// extracted by mini-css-extract-plugin
export var mt0 = "single-select-module--mt-0--5c293";
export var mt1 = "single-select-module--mt-1--400ff";
export var mt2 = "single-select-module--mt-2--bf823";
export var mt3 = "single-select-module--mt-3--86b25";
export var mt4 = "single-select-module--mt-4--531a2";
export var mt5 = "single-select-module--mt-5--d83cb";
export var mt6 = "single-select-module--mt-6--d499a";
export var singleSelect = "single-select-module--single-select--c27ee";
export var singleSelectDark = "single-select-module--single-select--dark--d607a";
export var singleSelectTransparent = "single-select-module--single-select--transparent--a23ff";
export var singleSelect__checkbox = "single-select-module--single-select__checkbox--4be4c";
export var singleSelect__fieldset = "single-select-module--single-select__fieldset--1e75f";
export var singleSelect__list = "single-select-module--single-select__list--29c3d";